import Vue from 'vue';
import Vuex from 'vuex';
import { alert } from './alert';
import { loading } from './loading';
import { login } from './login';
import { adminsite } from './adminsite';
import { region } from './region';
import { smart } from './smart';
import { user } from './user';
import { RootState } from './types';

Vue.use(Vuex);

export default new Vuex.Store<RootState>({
  state: {
    version: '1.0.0',
    menuVisible: false,
  },
  modules: {
    login,
    alert,
    loading,
    region,
    adminsite,
    smart,
    user,
  },
  mutations: {
    toggleMenu: (state) => {
      state.menuVisible = !state.menuVisible;
    },
    closeMenu: (state) => {
      state.menuVisible = false;
    },
    openMenu: (state) => {
      state.menuVisible = true;
    },
  },
  actions: {},
});
